import { createElement, HeadingHTMLAttributes } from 'react';
import { styled } from '@topwrite/common';

export default function Heading({ depth, id, children, ...props }: HeadingHTMLAttributes<HTMLHeadingElement>) {

    if (id) {
        children = <>
            <Anchor tabIndex={-1} id={id} />
            {children}
        </>;
    }

    return createElement(`h${depth}`, props, children);
}

const Anchor = styled.a`
  display: block;
  position: relative;
  top: -.5rem;
`;
